import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { BooleanColumnFilter, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { getCatalogInfo } from "sources/books/dictionaries";
import { delItem, restoreItem } from "sources/catalogs";

class OrganizationCatalogItems extends BookIndex {
    state = {
        catalogId: null,
        tableColumns: this.tableColumns,
    };

    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            { Header: "Название", accessor: "displayName", filterable: true },
            {
                Header: "Удален",
                accessor: "isDeleted",
                sortable: true,
                filterable: true,
                filterType: "boolean",
                Filter: (props) => {
                    const defaultValue = { id: "isDeleted", value: "false", filterType: "boolean" };
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Удаленные", value: "true" },
                        { label: "Не удаленные", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} defaultValue={defaultValue} />;
                },
                Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Действие",
                notExportable: true,
                width: 200,
                id: "action",
                sortable: false,
                Cell: ({ row }) => this.itemActions(row.original),
            },
        ];
    }

    componentDidMount() {
        getCatalogInfo(this.props.match.params.id).then(({ id }) => this.setState({ catalogId: id }));
    }

    close = () => {
        const { history } = this.props;
        history.push(paths.organizationCatalogs);
    };

    itemActions = (item) => {
        const restoreAction = () => {
            this.props.modal({
                name: "confirm",
                title: "Восстановление элемента",
                text: "Вы уверены, что хотите восстановить элемент?",
                action: () => restoreItem({ id: item.id }),
                buttons: { confirm: "Да", cancel: "Нет" },
                onSuccessAction: () => this.props.mergeParams({}),
            });
        };
        if (item.isDeleted) {
            return (
                <div className="btn btn-xs btn-brand" onClick={restoreAction}>
                    Восстановить
                </div>
            );
        }
        const deleteAction = () => {
            this.props.modal({
                name: "confirm",
                title: "Удаление элемента",
                text: "Вы уверены, что хотите удалить элемент?",
                action: () => delItem({ id: item.id, isDeleted: true }),
                buttons: { confirm: "Да", cancel: "Нет" },
                onSuccessAction: () => this.props.mergeParams({}),
            });
        };
        const editAction = () => {
            this.props.modal({
                name: "organizationCatalogItemForm",
                title: "Редактирование элемента",
                data: { ...item, catalogId: this.state.catalogId },
                callback: () => this.props.mergeParams({}),
            });
        };
        return (
            <>
                {this.state.catalogId && (
                    <div className="btn btn-xs btn-secondary mr-2" onClick={editAction}>
                        Изменить
                    </div>
                )}
                <div className="btn btn-xs btn-outline-danger" onClick={deleteAction}>
                    Удалить
                </div>
            </>
        );
    };

    renderCreateButton = () => {
        if (!this.state.catalogId) {
            return null;
        }
        const { modal, mergeParams } = this.props;
        const action = () =>
            modal({
                name: "organizationCatalogItemForm",
                title: "Создание элемента справочника",
                data: { catalogId: this.state.catalogId },
                mergeParams,
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Добавить элемент справочника
            </a>
        );
    };

    renderListComponent = () => {
        const { getList, ...props } = this.props;
        return (
            <SharedReactTable
                {...props}
                getList={(params) => getList({ ...params, externalId: props.match.params.id })}
                columns={this.state.tableColumns}
            />
        );
    };
}

export default tableContainer(OrganizationCatalogItems, "organizationcatalogitems");
